import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DirectionService } from '../../../shared/services/direction.service';
import { ApiService } from '@app/shared/services/api.service';
import { StoreService } from '@app/shared/services/store.service';
import { LocalStoreService } from '@app/shared/services/localStore.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-block-slideshow',
    templateUrl: './block-slideshow.component.html',
    styleUrls: ['./block-slideshow.component.scss']
})
export class BlockSlideshowComponent implements OnInit {
    @Input() withDepartments = true;
    @Input() onRefresh = true;
    @Input() ShowText = true;

    options = {
        nav: false,
        dots: true,
        loop: true,
        text: this.ShowText,
        responsive: {
            0: { items: 1 }
        },
        rtl: this.direction.isRTL()
    };

    slides = [];
    unsubscribe$: Subject<void> = new Subject<void>();

    constructor(
        public sanitizer: DomSanitizer,
        private direction: DirectionService,
        private apiServices: ApiService,
        public store: StoreService,
    ) {
        try {
            setTimeout(() => {
                // Get the 'store' item from local storage.
                const storeData = localStorage.getItem('store');

                // Check if storeData is not null before parsing and accessing properties.
                if (storeData) {
                    this.slides = JSON.parse(storeData).banners;
                } else {
                    // If 'store' doesn't exist, initialize slides as an empty array.
                    this.slides = [];
                }

                console.log(this.slides);
            }, 1000);
        } catch (error) {
            console.log(error);
        }
    }

    ngOnInit(): void {
        // this.storage.banners$.pipe(takeUntil(this.destroy$))
        //  .subscribe(v => this.slides = v);
    }
}
